export default "/assets/images/wildfire-smoke-video.mp4?28de9e1fd3e2b2227778988115b363cb";